import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_WAREHOUSE } from "../warehouse.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateWarehouseInput } from "../../../__generated__/globalTypes";
import {
  CreateWarehouseMutation,
  CreateWarehouseMutationVariables,
} from "../../../__generated__/CreateWarehouseMutation";

interface IProps {
  defaultValues: DeepPartial<CreateWarehouseInput>;
  onCompleted: () => any;
}

export const useCreateWarehouse = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateWarehouseInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateWarehouseMutation,
    CreateWarehouseMutationVariables
  >(CREATE_WAREHOUSE, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createWarehouse?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createWarehouse?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
